export default __webpack_public_path__ + "static/media/LogoR22.76645d66.png";